import Button from "@components/Button"
import ForgotPasswordDialog from "@components/ForgotPasswordDialog"
import Input from "@components/Input"
import Layout from "@components/Layout"
import PageHeader from "@components/PageHeader"
import { resetPasswordForEmail } from "@helpers/supabase"
import { validateEmail } from "@helpers/validations"
import { useState } from "react"
import { useTranslation } from "react-i18next"

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("")
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [emailFound, setEmailFound] = useState(true)
  const [errorKey, setErrorKey] = useState<string | null>(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const { t } = useTranslation()

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    setErrorKey(null)
    setIsSubmitting(true)

    const { error, isEmailNotFound, isRateLimited } =
      await resetPasswordForEmail({ email })

    setIsSubmitting(false)

    if (isRateLimited) {
      setErrorKey("pages.account.forgotPassword.rateLimited")
      return
    }

    if (error) {
      setErrorKey("shared.error")
      return
    }

    setEmailFound(!isEmailNotFound)
    setIsDialogOpen(true)
  }

  return (
    <>
      <Layout>
        <PageHeader
          emoji="📧"
          heading={t("pages.account.forgotPassword.heading")}
          subheading={t("pages.account.forgotPassword.enterEmail")}
        />

        <form className="custom-form" onSubmit={handleSubmit}>
          <div className="flex grow flex-col justify-between">
            <div className="mt-6">
              <Input
                autoFocus
                placeholder={t("shared.email")}
                onChange={(event) => setEmail(event.target.value)}
                type="email"
              />
              {errorKey && (
                <p className="mt-2 text-center text-sm text-red-500">
                  {t(errorKey)}
                </p>
              )}
            </div>

            <Button
              disabled={!validateEmail(email) || isSubmitting}
              title={t("pages.account.forgotPassword.resetPassword")}
              type="submit"
            />
          </div>
        </form>
      </Layout>

      {isDialogOpen && (
        <ForgotPasswordDialog
          open={isDialogOpen}
          onClose={() => setIsDialogOpen(false)}
          emailFound={emailFound}
        />
      )}
    </>
  )
}
